import { useRef, useState } from 'react';
import styled from '@emotion/styled/macro';
import { Box, Portal } from '@chakra-ui/react';
import { usePopper } from 'react-popper';

const Tooltip = ({ children, label, isDisabled, placement = 'bottom', ...restProps }) => {
    const referenceRef = useRef(null);
    const [popperElement, setPopperElement] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    const { styles, attributes } = usePopper(referenceRef.current, popperElement, {
        placement,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: 8,
                    boundary: 'viewport',
                },
            },
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['top', 'bottom'],
                },
            },
        ],
    });

    if (isDisabled) {
        return children;
    }

    return (
        <Wrapper {...restProps}>
            <div
                ref={referenceRef}
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                onFocus={() => setIsVisible(true)}
                onBlur={() => setIsVisible(false)}
                className="tooltip_children_wrapper"
                aria-describedby={isVisible ? 'tooltip' : undefined}
            >
                {children}
            </div>
            {isVisible && (
                <Portal>
                    <TooltipPopup
                        id="tooltip"
                        role="tooltip"
                        ref={setPopperElement}
                        style={styles.popper}
                        {...attributes.popper}
                    >
                        {label}
                    </TooltipPopup>
                </Portal>
            )}
        </Wrapper>
    );
};

const Wrapper = styled(Box)`
    display: inline-flex;

    .tooltip_children_wrapper {
        display: flex;
        width: 100%;
    }
`;

const TooltipPopup = styled.div`
    border-radius: 6px;
    background: var(--chakra-colors-gray-500);
    color: var(--chakra-colors-white);
    padding: 4px 8px;
    max-width: 250px;
    line-height: 18px;
    font-size: 12px;
    box-shadow: var(--chakra-shadows-md);
    z-index: 150;
    pointer-events: none;
    text-transform: capitalize;
    white-space: normal;
    word-wrap: break-word;
`;

export default Tooltip;
